import { FC, useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { CompetitionContext } from "../../CompetitionContext.tsx";
import { useCommand } from "../../hooks/useCommand.ts";
import { CompetitionCommand } from "../../commandTypes.ts";
import { getPresentationParamsForOrigin } from "../../getPresentationParamsForOrigin.ts";

export const Streamelements: FC = () => {
  const parsedUrl = new URL(window.location.href);
  const showBackgroundQueryParam = parsedUrl.searchParams.get("showBackground");

  // Set default title for stream overlays
  useEffect(() => {
    const competitionName = getPresentationParamsForOrigin().competitionName;
    document.title = `Stream | ${competitionName}`;
  }, []);

  // if query param is set and not "false", show background.
  // if query param is not set, use value of getPresentationParamsForOrigin.isDev
  const showBackground =
    showBackgroundQueryParam !== null
      ? showBackgroundQueryParam.toLowerCase() !== "false"
      : getPresentationParamsForOrigin().isDev;

  const [competitionId, setCompetitionId] = useState<string>(
    getPresentationParamsForOrigin().competitionId,
  );

  useCommand<CompetitionCommand>("competition", (c) => {
    setCompetitionId(c.competitionId);
  });

  return (
    <CompetitionContext.Provider value={competitionId}>
      <div
        style={{
          width: 1920,
          height: 1080,
          backgroundImage: showBackground
            ? "url(/img/screenshot-stream.jpg)"
            : undefined,
        }}
      >
        <Outlet />
      </div>
    </CompetitionContext.Provider>
  );
};
